import { render, staticRenderFns } from "./StyleGuidePage.vue?vue&type=template&id=59c8d64f&"
import script from "./StyleGuidePage.vue?vue&type=script&lang=js&"
export * from "./StyleGuidePage.vue?vue&type=script&lang=js&"
import style0 from "./StyleGuidePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports